/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";

const AxisSelectionFilterProductInfoSection = ({
  image,
  title1,
  title2,
  value,
  handleCheckboxChange,
  isSelected,
  disabled
}) => {
  const handleClick = () => {
    if (!disabled) {
      handleCheckboxChange({ target: { value, checked: !isSelected } });
    }
  };

  return (
    <div className="flex-1 flex items-center justify-center">
      <div
        className={`flex flex-col items-center justify-center space-y-1 w-fit
          border-2 border-transparent ${
            disabled ? "cursor-not-allowed opacity-50" : "hover:border-primary cursor-pointer"
          }
          rounded-md p-2`}
        onClick={handleClick}
      >
        <img src={image} className="max-h-[50px] mix-blend-multiply" alt={value} />
        <div className="text-center text-xs">
          <div className="font-semibold">{title1}</div>
          <div>{title2}</div>
        </div>
        <input
          key={value + isSelected}
          type="checkbox"
          className={`bg-white checked:bg-secondary rounded-sm border-gray-400 ${
            disabled ? "cursor-not-allowed border-gray-200 bg-gray-100" : "cursor-pointer"
          }`}
          value={value}
          checked={isSelected && !disabled}
          readOnly
          disabled={disabled}
          onClick={(e) => {
            // Prevent the click event from bubbling up to the parent div
            e.stopPropagation();
            if (!disabled) {
              handleCheckboxChange({ target: { value, checked: !isSelected } });
            }
          }}
        />
      </div>
    </div>
  );
};

export default AxisSelectionFilterProductInfoSection;
